import { apiCall } from './_helper';

// Gets a list of reports available in the system
// Tested and working: 4/6/2025
export const getReportList = async () => {
  return await apiCall({
    url: 'reports/reportList',
    reportingUrl: true,
    notJSON: true,
  });
};

// Gets the parameters required for a specific report
// Tested and working: 4/6/2025
export const getReportParams = async (reportId) => {
  return await apiCall({
    url: `reports/report?reportName=${reportId}`,
    reportingUrl: true,
    notJSON: true,
  });
};

// Fetches the report data based on the provided parameters
// Tested and working: 4/6/2025
export const getReport = async (endpoint, params) => {
  const formData = new FormData();
  Object.keys(params).forEach((k) => {
    formData.append(k, params[k]);
  });
  return await apiCall({
    url: `it/${endpoint}`,
    method: 'POST',
    body: formData,
    reportingUrl: true,
    notJSON: true,
  });
};
